import { css } from '@emotion/core';
import { tokens, variables } from '@domain-group/fe-brary';
var font = variables.font;
var allhomesListingCardListListingBadgeFontSize = '12px';
export var wrapper = /*#__PURE__*/css("position:absolute;top:0;left:0;font-family:", font.bodyFontFamily, ";font-weight:", font.headingFontWeight, ";font-size:", allhomesListingCardListListingBadgeFontSize, ";opacity:0.9;");
export var badge = function badge(badgeEnum) {
  var bgColour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : badgeEnum.colour;
  var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : badgeEnum.textColour || tokens.colors.neutral.heavy.default;
  return /*#__PURE__*/css("margin-right:1px;padding:3px 5px;display:inline-block;color:", color, ";background-color:", bgColour, ";");
};